import AccountTreeOutlined from "@mui/icons-material/AccountTreeOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CategoryOutlined from "@mui/icons-material/CategoryOutlined";
import WarehouseOutlined from "@mui/icons-material/WarehouseOutlined";
import GroupsOutlined from "@mui/icons-material/GroupsOutlined";
import Inventory2Outlined from "@mui/icons-material/Inventory2Outlined";
import MiscellaneousServicesOutlined from "@mui/icons-material/MiscellaneousServicesOutlined";
import VerifiedUserOutlined from "@mui/icons-material/VerifiedUserOutlined";
import { Box, Divider, ListItemIcon, ListItemText, Typography } from "@mui/material";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { StyledSideNav } from "styles";
import { hasRole, isSuperAdmin, ROLES } from "utils/auth";

const itemSx = {
  borderRadius: "10px",
  mb: "2px",
  px: 1.5,
  py: 1,
  color: "#565B76",
  "& .MuiListItemIcon-root": { minWidth: 0, mr: 1.25, color: "#8288A6" },
  "&:hover": { background: "#F5F6FA" },
  "&.Mui-selected": {
    background: "#EEF0FA",
    boxShadow: "inset 3px 0 0 #1E2A8A",
    color: "#1E2A8A",
    "& .MuiListItemIcon-root": { color: "#1E2A8A" },
    "&:hover": { background: "#E7EAF7" },
  },
};

// Super Admin only.
const superAdminNavList = [
  {
    title: "Permission Matrix",
    path: "/configuration/permissions",
    icon: VerifiedUserOutlined,
  },
];

// Users hub — visible to Super Admin and Administrators.
const staffNavList = [
  {
    title: "Users",
    path: "/configuration/users",
    icon: GroupsOutlined,
  },
];

const sideNavList = [
  {
    title: "Branch",
    path: "/configuration/branches",
    icon: AccountTreeOutlined,
  },
  {
    title: "Warehouse Locations",
    path: "/configuration/warehouse-locations",
    icon: WarehouseOutlined,
  },
  {
    title: "Service Category",
    path: "/configuration/service-category",
    icon: CategoryOutlined,
  },
  {
    title: "Services",
    path: "/configuration/services",
    icon: MiscellaneousServicesOutlined,
  },
  {
    title: "Service Packages",
    path: "/configuration/service-packages",
    icon: Inventory2Outlined,
  },
];

const ConfigSideBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const items = [
    ...(hasRole(ROLES.SUPER_ADMIN, ROLES.ADMIN) ? staffNavList : []),
    ...(isSuperAdmin() ? superAdminNavList : []),
    ...sideNavList,
  ];

  return (
    <StyledSideNav>
      <Box mt="20px" display="flex" alignItems="center" gap={1} px="20px">
        <ArrowBackIcon
          onClick={() => navigate("/dashboard")}
          sx={{ cursor: "pointer", color: "#1E2A8A", fontSize: 20 }}
        />
        <Typography variant="h5" fontSize="16px" color="#1a1c2e">
          Settings
        </Typography>
      </Box>
      <Divider sx={{ borderColor: "#ECEEF4", mt: 2 }} />
      <List sx={{ px: 1.5, pt: 1.5 }}>
        {items.map((item) => {
          const Icon = item.icon;
          const selected = location.pathname.startsWith(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              style={{ textDecoration: "none" }}
            >
              <ListItemButton selected={selected} sx={itemSx}>
                <ListItemIcon>
                  <Icon sx={{ fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography
                      sx={{
                        color: "inherit",
                        fontSize: "14px",
                        fontFamily: selected
                          ? "albertSans_semibold"
                          : "albertSans_regular",
                      }}
                    >
                      {item.title}
                    </Typography>
                  }
                />
              </ListItemButton>
            </Link>
          );
        })}
      </List>
    </StyledSideNav>
  );
};

export default ConfigSideBar;
